export const initial = {
  artId: null,
  bearbeitung: null,
  startJahr: null,
  umsetzung: null,
  bearbeiter: null,
  ekfBeobachtungszeitpunkt: null,
}

export const simpleTypes = {
  artId: 'uuid',
  bearbeitung: 'number',
  startJahr: 'number',
  umsetzung: 'number',
  bearbeiter: 'uuid',
  ekfBeobachtungszeitpunkt: 'string',
}
